module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    class: _vm.isMobile() ? 'modal--small' : 'modal--medium',
    style: (_vm.modalStyle()),
    attrs: {
      "show": _vm.show,
      "data-backdrop": "static",
      "clickToClose": "false",
      "data-keyboard": "false"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    style: (_vm.mainDivStyle())
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-left": "20px",
      "cursor": "pointer"
    }
  }, [_c('img', {
    staticClass: "modal-back-arrow",
    attrs: {
      "src": require("../assets/img/icons/arrow_left.svg")
    },
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "foo",
    staticStyle: {
      "margin-bottom": "10px",
      "cursor": "pointer"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), (_vm.videoView) ? _c('video', {
    attrs: {
      "id": "videoPlayer",
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.videoFile,
      "type": "video/mp4"
    }
  }), _vm._v("\n          Your browser does not support the video tag.\n        ")]) : _vm._e(), _vm._v(" "), _c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "border-radius": "20px"
    },
    attrs: {
      "id": "videoIframe",
      "src": _vm.iFrameUrl,
      "sandbox": "allow-scripts allow-same-origin allow-presentation",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
      "referrerpolicy": "strict-origin-when-cross-origin",
      "allowfullscreen": ""
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-23a6ec58!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/PlayVideoDialog.vue
// module id = 718
// module chunks = 0